import { TextData } from "interfaces/TextEditor";

export function GetTextData(this: any): any {
  try {
    const { updatedHtmlContent, content, values, groupName } = this ?? {};
    const { id, textName } = content;
    return {
      id: id != "" && textName == values?.textName ? id : values.textName,
      textName: values?.textName,
      text: updatedHtmlContent,
      group: groupName,
    };
  } catch (error) {
    return {};
  }
}
